module.exports = __webpack_public_path__ + "static/screenshotshortcuts-35c68f3d4fb98ec47af9276caabde0c1.png";